<div class="raw-json-modal__backdrop animated fadeIn">
	<div class="raw-json-modal__wrapper">
		<div class="raw-json-modal">
			<div class="raw-json-modal__header">
				<h3 class="raw-json-modal__title">{{data?.title}} {{data?.options['type']}}</h3>
			</div>
			<div class="raw-json-modal__content">
				<ngx-json-viewer [json]="data?.options['item']" [depth]="2"></ngx-json-viewer>
			</div>
			<div class="raw-json-modal__actions">
				<button class="raw-json-modal__close" (click)="closeEvent()">Close</button>
			</div>
		</div>
	</div>
</div>
